import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect } from "react";
import { useCallback } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import Button from "../../../../components/Common/Button/Button";
import Input from "../../../../components/Common/Input/Input";
import {
  getPasswordExpiryPeriodActionHandler,
  setPasswordExpiryPeriodActionHandler,
} from "../../../../store/actions/actionHandlers/adminActionHandler/organizationActionHandler";
import { PasswordExpirationSchema } from "../../../../utils/mainTabs/admin/organizationSettings/passwordExpirationSchema";
import classes from "./PasswordExpiration.module.scss";
import { FormattedMessage } from "react-intl";

const PasswordExpiration = () => {
  const dispatch = useDispatch();
  const adminStateReducer = useSelector((state) => state.adminReducer);
  const { organizationSettingsReducer } = adminStateReducer;
  const { getPasswordExpiryLoader, setPasswordExpiryLoader } =
    organizationSettingsReducer;

  const methods = useForm({
    defaultValues: { PasswordExpiration: "" },
    resolver: yupResolver(PasswordExpirationSchema),
    mode: "onChange",
  });
  const {
    handleSubmit,
    reset,
    formState: { isValid, errors },
  } = methods;

  const getPasswordExpiryPeriod = useCallback(() => {
    dispatch(getPasswordExpiryPeriodActionHandler()).then(
      (passwordExpirationPeriod) => {
        let formData = {
          PasswordExpiration: passwordExpirationPeriod,
        };
        reset(() => formData);
      }
    );
  }, [dispatch, reset]);

  useEffect(() => {
    getPasswordExpiryPeriod();
  }, [getPasswordExpiryPeriod]);

  const submitPasswordExpirationPeriod = (data) => {
    dispatch(setPasswordExpiryPeriodActionHandler(data.PasswordExpiration));
  };

  return (
    <FormProvider {...methods}>
      <form
        className={classes.passwordExpiration}
        onSubmit={handleSubmit(submitPasswordExpirationPeriod)}
      >
        <Input
          name="PasswordExpiration"
          label="Password Expiry Period"
          placeholder="In Days. Ex: 360"
          error={errors?.PasswordExpiration?.message}
          loading={getPasswordExpiryLoader}
        />
        <Button
          label={<FormattedMessage id="SAVE_TXT" />}
          disabled={!isValid}
          type="submit"
          dark
          small
          loading={setPasswordExpiryLoader}
        />
      </form>
    </FormProvider>
  );
};

export default PasswordExpiration;
